import { useReactiveVar } from '@apollo/client';
import { MoreVert } from '@mui/icons-material';
import {
  TableRow,
  TableCell,
  IconButton,
  Tooltip
} from '@mui/material';
import _ from 'lodash';

import {
  menuUtil,
  reactiveVariables
} from 'modules/common';

import { InstallationTypeMenu } from 'modules/components/layer19';


import React from 'react';



export type ProjectInstallationSummaryRowProps = {
  id: string;
  projectId: string;
  type: string;
  numberOfActiveInstallations: number;
  numberOfCompletedInstallations: number;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectInstallationSummaryRowProps) => {
  const {
    anchorEl,
    handleClick,
    handleClose,
    open
  } = menuUtil.useBaseMenuState();
  const installationFilter = useReactiveVar(reactiveVariables.filterInstallationsVar);

  const toolTipTitle = __generateToolTipTitle(installationFilter);
  return (
    <TableRow
      content='list'
      onClick={() => {
        reactiveVariables.filterInstallationsVar({
          ...installationFilter,
          installationTypeId: props.id,
          isGrouped: !installationFilter.isGrouped
        });
      }}
    >

      <TableCell
        variant='body'
      >
        {props.type}
      </TableCell>
      <TableCell
        variant='body'
      >

        {props.numberOfActiveInstallations}
      </TableCell>
      <TableCell
        variant='body'
      >

        {props.numberOfCompletedInstallations}
      </TableCell>

      <TableCell
        align='right'
        variant='lastRounded'
      >
        <Tooltip
          title={toolTipTitle}
          followCursor
        >
          <IconButton
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (toolTipTitle === '') {
                handleClick(e);
              }
            }}
          >
            <MoreVert />
          </IconButton>
        </Tooltip>
        {open && (
          <InstallationTypeMenu.FC
            anchorEl={anchorEl}
            handleClick={handleClick}
            handleClose={handleClose}
            id={props.id}
            projectId={props.projectId}
            open={open}
          />
        )}
      </TableCell>
    </TableRow>
  );

};


const __generateToolTipTitle = (filter: reactiveVariables.IFilterInstallationsVar) => {
  let isFilterEmpty = true;
  if (filter.areaId) {
    isFilterEmpty = false;
  } else if (!_.isNil(filter.roomName)) {
    isFilterEmpty = false;
  } else if (!_.isNil(filter.freeTextSearch)) {
    isFilterEmpty = false;
  } else if (_.isNil(filter.isComplete)) {
    isFilterEmpty = false;
  } else if (_.isNil(filter.isOverDue)) {
    isFilterEmpty = false;
  } else if (_.isNil(filter.isRemaining)) {
    isFilterEmpty = false;
  } else if (_.isNil(filter.isUpcoming)) {
    isFilterEmpty = false;
  } else if (_.isNil(filter.milestoneId)) {
    isFilterEmpty = false;
  }

  if (!isFilterEmpty) {
    return 'Please Clear Filter';
  }
  return '';
};
